module.exports = __webpack_public_path__ + "img/22_56.988dfdb7.png";